// @flow
import React from 'react';

import notification from 'antd/lib/notification';

import { passApi } from '../../../../../lib/api';
import type { Pass } from '../../../../../lib/types';

import Filter from '../../../../services/pass/Filter';
import { PASS_COLUMNS } from '../../../../services/pass';

import { ListTable } from '../../../lib';

export default class extends ListTable<Pass> {
  fetch = async (page: number = 1) => {
    const { isTax } = this.props;
    const params = super.fetch(page);
    try {
      const data = await passApi.fetchPasses(params);
      const totalSum = isTax
        ? await passApi.getTaxTotalSum(params)
        : await passApi.getTotalSum(params);
      this.setState({ ...data, totalSum, loading: false, page });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  render() {
    return (
      <>
        {super.renderFilter(Filter)}
        {super.renderTable(PASS_COLUMNS, 'paymentAmountPass')}
      </>
    );
  }
}
